<template lang="pug">
.LEADERSHIPOFFICE
  .roomTitle(v-once) {{ cont.departmentName }}
    .tl.point
    .tr.point
    .bl.point
    .br.point
  component(
    :is="single",
    v-if="single",
    :cont="EliminateControl[controList]",
    @Determine="Determine"
  )
  ArrControl(
        v-if="controlState",
        :cont="EliminateControl[controList]",
        @Determine="Determine"
      )
  .content-main(
    v-else
    :style="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导' ? '' : 'flex-direction: row-reverse;'"
  )
    img(
      src="../../../assets/doCase/head/ld.png",
      v-if="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导'"
    )
    img(src="../../../assets/doCase/head/xz.png", v-else)
    .content(:class="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导'?'left-bubbl':'right-bubbl'")
      .title {{ dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导' ? '领导' : '小张' }}
      img.img.left-img(src="../../../assets/doCase/yinhao.png")
      .LEADERSHIPOFFICE-content(:style='{width:getContentWidth}') {{ dialogueList[contState].content }}
      button.next(@click="next", :class="{ Disabling: AssessmentState }") 下一步
      //- button.next1.next(@click='Assessment',v-if='AssessmentState')  {{findTitle()}}
      button.next1.next(@click="Assessment", v-if="AssessmentState") 内容
      //- button.next1.next(@click="Assessment",) 内容
      img.img.right-img(src="../../../assets/doCase/yinhao.png")
</template>

<script>
/* eslint-disable prettier/prettier */
import ArrControl from "@/components/doCase/doControl/ArrControl"; // 欢迎进入控件
import MATERIALANALYSISPROBLEM from "@/components/doCase/doControl/doSubject/MATERIALANALYSISPROBLEM"; // 欢迎进入控件
import bus from "@/utils/main";
import doCase from "@/mixins/case/doCase";
export default {
  mixins: [doCase],
  components: { ArrControl, MATERIALANALYSISPROBLEM },
  props: ["cont"],
  computed: {
    getContentWidth() {
      // 32左右边距、40图片宽度、100按钮宽度、20按钮边距
      if (this.AssessmentState) return "calc( 100% - (32px + 40px) * 2 - 100px * 2 - 20px)";
      return "calc( 100% - (32px + 40px) * 2 - 100px * 1)";
    }
  },
  data() {
    return {
      dialogueList: [],
      AloneControl: ["MATERIALANALYSISPROBLEM", "DIALOGUE"],
      contState: 0,
      single: "",
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      controlState: false,
      AssessmentState: false,
      sceneControlList: [],
      controList: 0,
      AssessmentIndex: -1, // 场景里的第几个控件
      EliminateControl: [], // 处理后的控件
      btnState: true
    };
  },
  methods: {
    // findTitle() {
    //   console.sun(this.sceneControlList[this.contState]);
    //   const arr = [
    //     "SINGLECHOICE",
    //     "MULTIPLECHOICEA",
    //     "MULTIPLECHOICEB",
    //     "GAPFILLING",
    //     "ESSAYQUESTION",
    //     "FILLBLANKS"
    //   ];

    //   if (arr.indexOf(this.sceneControlList[this.contState].type) > 0) {
    //     return "题目";
    //   }
    //   return "资料";
    // },
    query() {
      const data = {
        caseHallId: this.cont
          ? this.cont.id
          : this.$store.state.doCase.caseData[
              // eslint-disable-next-line indent
              this.step[+sessionStorage.getItem("doIndex")]
            ].tsId,
        classId: sessionStorage.getItem("classId"),
        experimentId: this.$store.state.doCase.experimentId,
        pyId: this.$store.state.doCase.caseId,
        tsId: this.$store.state.doCase.caseData[this.step[+sessionStorage.getItem("doIndex")]].tsId,
        userId: this.$role.code
      };
      this.$http.listStuControl(data).then(res => {
        console.log(res);
        const find = value => {
          return this.EliminateControl[this.controList].id === value.controlId;
        };
        console.log(res.data.data.find(find));
        if (res.data.data.find(find)) {
          bus.$emit("onesbChange", res.data.data.find(find));
        }
      });
    },
    Determine() {
      this.single = "";
      if (this.EliminateControl.length > this.controList + 1) {
        console.log(this.EliminateControl);
        this.controList += 1;
        this.controlState = false;
        if (Array.isArray(this.EliminateControl[this.controList])) {
          this.controlState = true;
        } else {
          console.log(this.EliminateControl[this.controList].type);
          if (this.EliminateControl[this.controList].type === "DIALOGUE") {
            this.dialogueList = this.dialogueList.concat(
              JSON.parse(this.EliminateControl[this.controList].metas)
            );
            console.log(this.dialogueList);
            this.contState += 1;
            this.AssessmentState = false;
            if (this.dialogueList.length === this.contState + 1) {
              if (Array.isArray(this.EliminateControl[this.controList + 1])) {
                this.AssessmentState = true;
              }
            }
            return;
          }
          this.single = this.EliminateControl[this.controList].type;
          this.query();
        }
      } else {
        this.$emit("SignOut");
      }

      this.$forceUpdate();
    },
    Assessment() {
      if (this.controList !== 0) {
        // if (Array.isArray(this.EliminateControl[this.controList])) {
        this.controList += 1;
        this.controlState = true;
        return;
        // }
      }
      /** 评估方案按钮 */
      //
      // this.EliminateControl = Array(
      //   +this.sceneControlList[this.sceneControlList.length - 1].pageNumber
      // );
      //       /** 开始大厅的控件 */
      const contList = [];
      let data = [];
      let num = 0;
      this.sceneControlList.forEach((element, index) => {
        if (num === +element.pageNumber) {
          if (this.AloneControl.indexOf(element.type) === -1) {
            data.push(element);
            if (index === this.sceneControlList.length - 1) {
              if (data.length !== 0) {
                contList.push(data);
              }
            }
          } else {
            if (data.length !== 0) {
              contList.push(data);
            }
            contList.push(element);
            data = [];
          }
        } else if (this.AloneControl.indexOf(element.type) === -1) {
          if (data.length !== 0) {
            contList.push(data);
          }
          data = [];
          data.push(element);
          if (index === this.sceneControlList.length - 1) {
            contList.push(data);
          }
        } else {
          if (data.length !== 0) {
            contList.push(data);
          }
          contList.push(element);
          data = [];
        }
        num = +element.pageNumber;
      });
      this.EliminateControl = contList;
      this.controlState = true;
    },
    next() {
      if (!this.btnState) {
        return;
      }
      this.btnState = false;
      this.$http
        .ping()
        .then(() => {
          /** 点击下一步按钮 */
          if (!this.AssessmentState) {
            if (this.dialogueList.length === this.contState + 2) {
              // debugger;

              this.AssessmentState = true;
              if (this.controList + 1 === this.EliminateControl.length) {
                this.AssessmentState = false;
              }
              if (Array.isArray(this.EliminateControl[this.controList + 1])) {
                this.AssessmentState = true;
              }
            }
            if (this.dialogueList.length === this.contState + 1) {
              this.$emit("SignOut");
            }
            if (this.sceneControlList.length === 0) {
              this.AssessmentState = false;
            }
            this.contState += 1;
          }
          this.btnState = true;
        })
        .catch(() => {
          this.$Message.error("网络连接异常");
          this.btnState = true;
        });
    }
  },
  created() {
    this.dialogueList = JSON.parse(this.cont.functionName);
    console.log(this.dialogueList);
    if (this.dialogueList.length === 1) {
      this.AssessmentState = true;
    }
    this.doCaseQueryControl();
  }
};
</script>

<style lang="stylus" scoped>
.LEADERSHIPOFFICE
  position absolute
  background url('../../../assets/case/department/leadershipOffice.png')
  background-size 100vw
  height 100vh
  width 100vw
  z-index 5
  .roomTitle
    position absolute
    top 76px
    left 0
    right 0
    margin 0 auto
    width 150px
    height 40px
    background-color rgba(245, 166, 35, 1)
    border-radius 4px
    opacity 0.8022
    font-size 18px
    font-family fzhpfw
    font-weight normal
    color rgba(255, 255, 255, 1)
    line-height 40px
    .point
      width 4px
      height 4px
      background rgba(255, 255, 255, 1)
      border-radius 2px
      opacity 0.3043
      &:nth-child(1)
        position absolute
        top 4px
        left 6px
      &:nth-child(2)
        position absolute
        top 4px
        right 6px
      &:nth-child(3)
        position absolute
        bottom 4px
        left 6px
      &:nth-child(4)
        position absolute
        bottom 4px
        right 6px
.content-main
  transition 1s all
  margin 0 32px
  position absolute
  height 156px
  bottom 32px
  width calc(100% - 64px)
  text-align left
  overflow hidden
  display flex
  .content
    position relative
    margin 0 32px
    // height 156px
    height 160px
    background linear-gradient(180deg, #EAEBE4 0%, #FFFFFF 100%)
    box-shadow 0px -2px 4px 0px rgba(0, 0, 0, 0.1)
    opacity 0.94
    text-align left
    width 100%
    border-radius 8px
    .title
      font-size 24px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 28px
      margin 22px 67px
    .img
      width 40px
      transform rotate(180deg)
    .left-img
      // margin-left 110px
      margin-left 10px
      float left
    .right-img
      float right
      // margin-right 150px
    .next
      width 100px
      height 40px
      background rgba(58, 118, 210, 1)
      border-radius 4px
      border none
      outline none
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 1)
      line-height 18px
      float right
      // margin-right 163px
      margin-right 32px
    .next1
      margin-right 16px
    .LEADERSHIPOFFICE-content
      font-size 16px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      line-height 28px
      float left
      margin-left 5px
      // width 55%
      width calc( 100% - (32px + 40px) * 2 - 100px * 2 - 20px)
      // 2021年3月10日 多的话，就滚动——1063
      max-height 84px
      overflow-y scroll
    .Disabling
      background #dddddd
.right-bubbl:after
  content ''
  position absolute
  left 100%
  top 32px
  width 24px
  height 24px
  border-width 0
  border-style solid
  border-color transparent
  border-bottom-width 18px
  border-bottom-color currentColor
  border-radius 0 0 32px 0
  color #FFFFFF
  opacity: 0.94;
.left-bubbl:after
  content:'';
  position:absolute;
  right:100%;
  top:32px;
  width:24px;
  height:24px;
  border-width:0;
  border-style:solid;
  border-color:transparent;
  border-bottom-width:18px;
  border-bottom-color:currentColor;
  border-radius:0 0 0 32px;
  color:#FFFFFF;
  opacity: 0.94;
</style>
